import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'

import css from './styles.css'

const TextAreaLabel = ({ textAreaLabel, onChange }) => (
  <div>
    <span>
      Update the text area label (default is 'Message'):
    </span>
    <div className={css.textAreaLabelContainer}>
      <Form.Item key="textAreaLabel" className={css.extraQuestionField}>
        <Input
          name={textAreaLabel}
          onChange={e => onChange(e)}
          value={textAreaLabel}
          placeholder="Insurance Information"
        />
      </Form.Item>
    </div>
  </div>
)

TextAreaLabel.propTypes = {
  textAreaLabel: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default TextAreaLabel



// WEBPACK FOOTER //
// ./src/AddPractice/Info/SchedulingWidgetSnippet/TextAreaLabel.js